const CryptoJS = require('crypto-js');

const ENCRYPTION_KEY = CryptoJS.enc.Base64.parse(process.env.REACT_APP_ENCRYPTION_KEY); // AES-256 key (32 bytes)
const AUTHENTICATION_KEY = CryptoJS.enc.Base64.parse(process.env.REACT_APP_AUTHENTICATION_KEY); // HMAC key (32 bytes)


export const encryptData = (data) => {
  
  // Generate Initialization Vector (IV)
  const iv = CryptoJS.lib.WordArray.random(16);
  
  // Convert payload to string
  const payloadString = JSON.stringify(data);

  // Encrypt the payload
  const encrypted = CryptoJS.AES.encrypt(payloadString, ENCRYPTION_KEY, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const encryptedPayload = encrypted.toString();

  // Calculate HMAC for the encrypted payload
  const hmac = CryptoJS.HmacSHA256(encryptedPayload, AUTHENTICATION_KEY).toString(CryptoJS.enc.Base64);

  // Return the encrypted payload and headers
  return {
    encryptedPayload,
    headers: {
      'x-encryption-iv': iv.toString(CryptoJS.enc.Base64),
      'x-authentication-mac': hmac,
    },
  };
};

export const decryptData = (encryptedPayload, iv, receivedHmac) => {
    try {
        // Verify HMAC
        console.log('AUTHENTICATION_KEY',AUTHENTICATION_KEY);
        const calculatedHmac = CryptoJS.HmacSHA256(encryptedPayload, AUTHENTICATION_KEY).toString(CryptoJS.enc.Base64);
        console.log('Calculated HMAC:', calculatedHmac, receivedHmac);
  
        if (calculatedHmac !== receivedHmac) {
            return {
                statusCode: 403,
                message: 'Invalid HMAC signature',
            };
        }
        console.log('Payload:', encryptedPayload);
  
        // Decrypt the payload
        const decryptedBytes = CryptoJS.AES.decrypt(encryptedPayload, ENCRYPTION_KEY, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
        console.log('Decrypted data:', JSON.parse(decryptedData));
  
        // Check if decryptedData is not an empty string
        if (!decryptedData) {
            return {
                statusCode: 401,
                message: 'Authentication error',
            };
        }
        return JSON.parse(decryptedData); // Parse the decrypted data as JSON
    } catch (err) {
        console.error('Error decoding API key:', err);
        return {
            statusCode: 401,
            message: 'Authentication error',
        };
    }
};